import { createSlice } from '@reduxjs/toolkit';
import reducers from './reducers';
import extraReducers from './extraReducers';
import type { CustomerHistoryEntry } from '../../thunk/customerHistory';

export * from '../../thunk/customerHistory';

export interface CustomerHistoryState {
    /** Keyed by `historyKey(args)`; see the thunk. */
    data: Record<string, CustomerHistoryEntry>;
    status: 'loading' | 'resolved' | 'rejected' | null;
    error: string | null;
}

const initialState: CustomerHistoryState = {
    data: {},
    status: null,
    error: null,
};

const CustomerHistorySlice = createSlice({
    name: 'customerHistory',
    initialState,
    reducers,
    extraReducers,
});
const { actions, reducer } = CustomerHistorySlice;
export const { setCustomerHistory, clearCustomerHistory } = actions;
export { reducer };
